const axios = require('axios').default;

import Quiz from "./test/Quiz";
import Question from "./test/Question";
import Answer from "./test/Answer";
import Result from "./test/Result";

export default function Test() {

    console.log('start test')

    if(typeof test_id !== 'undefined'){
        var quiz = null;
        var data = new FormData();
        data.append('action', 'tests');
        data.append('test_id', test_id);
        axios.post('/wp-admin/admin-ajax.php', data)
            .then(function (response) {
                // обработка успешного запроса

                let questions = [],
                    results = [];

                response.data.data.voprosy.forEach(vopros => {
                    let answers = [];
                    vopros.otvety.forEach(otvet => {
                        answers.push(new Answer(otvet.tekst_otveta, +otvet.ball));
                    })
                    questions.push(new Question(vopros.vopros, answers));
                })

                response.data.data.vychisleniya.forEach(vychislenie => {
                    results.push(new Result(vychislenie.rezultat, +vychislenie.ot, +vychislenie.do));
                })

                quiz = new Quiz(0, questions, results);

                console.log(quiz);
            })
            .catch(function (error) {
                // обработка ошибки
                console.log(error);
            })
            .finally(function () {
                // выполняется всегда
            });
    }

    document.querySelectorAll('.b-test').forEach(test => {
        let preview = test.querySelector('.b-test__preview'),
            previewButton = preview.querySelector('input[type=button]'),
            testContainer = test.querySelector(".b-test__container"),
            resultElem = test.querySelector(".b-test__result"),
            questionElem = test.querySelector(".b-test__question"),
            buttonsElem = test.querySelector(".b-test__answers"),
            statsElem = test.querySelector(".b-test__stats"),
            motivElem = test.querySelector(".b-test__motiv");

        previewButton.addEventListener('click', (e) => {
            testContainer.classList.remove('b-test__container--disable');
            preview.classList.add('b-test__preview--disable');
            Update();
        })

        function Update() {
            //Проверяем, есть ли ещё вопросы
            if (quiz.current < quiz.questions.length) {
                //Если есть, меняем вопрос в заголовке
                questionElem.innerHTML = quiz.questions[quiz.current].text;

                //Удаляем старые варианты ответов
                buttonsElem.innerHTML = "";

                //Создаём кнопки для новых вариантов ответов
                for (let i = 0; i < quiz.questions[quiz.current].answers.length; i++) {
                    let btn = document.createElement("button");
                    btn.className = "b-test__button button";

                    btn.innerHTML = quiz.questions[quiz.current].answers[i].text;

                    btn.setAttribute("index", i);

                    buttonsElem.appendChild(btn);
                }

                //Выводим номер текущего вопроса
                statsElem.innerHTML = '<div class="b-test__progress"><div class="b-test__progress-line" style="width: ' + ((100 / quiz.questions.length) * (quiz.current + 1)) + '%;"></div><span>' + 'Вопрос ' + (quiz.current + 1) + " / " + quiz.questions.length + '</span></div>';
                //Вызываем функцию, которая прикрепит события к новым кнопкам
                Init();
            } else {
                //Если это конец, то выводим результат
                buttonsElem.innerHTML = "";
                buttonsElem.classList.add('b-test__answers--disable');
                questionElem.innerHTML = "";
                questionElem.classList.add('b-test__question--disable');
                resultElem.innerHTML = quiz.results[quiz.result].text;

                resultElem.classList.remove('b-test__result--disable');
                //statsElem.innerHTML = "Результат: " + quiz.score + " балл";
                statsElem.innerHTML = "";
                motivElem.classList.remove('b-test__motiv--disable');
                console.log("Результат: " + quiz.score + " балл");
            }
        }

        function Init() {
            //Находим все кнопки
            let btns = document.getElementsByClassName("b-test__button");

            for (let i = 0; i < btns.length; i++) {
                //Прикрепляем событие для каждой отдельной кнопки
                //При нажатии на кнопку будет вызываться функция Click()
                btns[i].addEventListener("click", function (e) {
                    Click(e.target.getAttribute("index"));
                });
            }
        }

        function Click(index) {
            //Получаем номер правильного ответа
            let correct = quiz.Click(index);

            //Находим все кнопки
            let btns = document.getElementsByClassName("b-test__button");

            //Делаем кнопки серыми
            for (let i = 0; i < btns.length; i++) {
                btns[i].className = "b-test__button button button_passive";
            }

            //Если это тест с правильными ответами, то мы подсвечиваем правильный ответ зелёным, а неправильный - красным
            if (quiz.type === 1) {
                if (correct >= 0) {
                    btns[correct].className = "b-test__button button button_correct";
                }

                if (index !== correct) {
                    btns[index].className = "b-test__button button button_wrong";
                }
            } else {
                //Иначе просто подсвечиваем зелёным ответ пользователя
                btns[index].className = "b-test__button button button_correct";
            }
            Update()
            //Ждём секунду и обновляем тест
            //setTimeout(Update, 100);
        }
    })

}